module.exports = __webpack_public_path__ + "img/outer-card-form.64f45609.svg";